import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { initAnalytics, resolveAnalytics } from '@easydent/shared-ui';
import { useAuthStore } from '@/stores/authStore';
import AppCookieBanner from '@/components/AppCookieBanner';
import LoginPage from '@/pages/LoginPage';
import DemoPage from '@/pages/DemoPage';
import WorklistPage from '@/pages/WorklistPage';
import ReferralDetailPage from '@/pages/ReferralDetailPage';
import BillingPage from '@/pages/BillingPage';
import AccountPage from '@/pages/AccountPage';

const RequireCentre: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const App: React.FC = () => {
  // Consent-gated analytics. Stays off until this app has a website id AND the visitor consents.
  useEffect(() => {
    initAnalytics(resolveAnalytics('imaging'));
  }, []);

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/" element={<RequireCentre><WorklistPage /></RequireCentre>} />
        <Route path="/referrals/:id" element={<RequireCentre><ReferralDetailPage /></RequireCentre>} />
        <Route path="/billing" element={<RequireCentre><BillingPage /></RequireCentre>} />
        <Route path="/account" element={<RequireCentre><AccountPage /></RequireCentre>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* Rendered here, not per page — the login and demo pages have no shared layout to carry it. */}
      <AppCookieBanner />
    </>
  );
};

export default App;
